import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { globalSettingsIssueFieldConfigurationSchemesRoute } from '@atlassian/jira-router-routes-admin-pages-field-configuration-schemes-routes/src/globalSettingsIssueFieldConfigurationSchemesRoute.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalAdminFieldConfigurationSchemesEntryPoint } from '@atlassian/jira-admin-pages-field-configuration-schemes/entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: globalAdminFieldConfigurationSchemesEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const globalSettingsIssueFieldConfigurationSchemesRouteEntry = createEntry(
	globalSettingsIssueFieldConfigurationSchemesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.field-configuration-schemes',
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},
		canTransitionIn: () => fg('jira_efa_for_cmp_m2'),
		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],
		entryPoint: () => {
			if (!fg('jira_efa_for_cmp_m2')) {
				return undefined;
			}

			return pageEntryPoint;
		},
		meta: {
			reporting: {
				packageName: 'jiraAdminPagesFieldConfigurationSchemes',
				id: 'globalSettingsIssueFieldConfigurationSchemes',
				teamName: 'Yamato',
			},
		},
	}),
);
